import React from 'react'
import { Routes, Route, BrowserRouter } from "react-router-dom";

/* Rutas publicas*/
import { Certificados } from '../components/certificados/Certificados';
import { RegisterExtension } from '../components/register/registerExtension';
import { RegisterEstudiantes } from '../components/register/registerEstudiantes';


export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/certificados/:identificacion" element={<Certificados />} />
        {/* Diseno nuevo (feature/new_desing) en /extension */}
        <Route path="/extension" element={ <RegisterExtension /> } />
        <Route path="/register" element={ <RegisterEstudiantes /> } />
        {/* Diseno clasico (el de la rama production) en la raiz */}
        <Route path="/" element={ <RegisterEstudiantes /> } />
      </Routes>
    </BrowserRouter>
  )
}
